module.exports = __webpack_public_path__ + "static/media/dubai.aa3747ec.jpg";